<template>
    <div>
        <b-row class="mt-3">
            <b-col md="4"
                   class="mb-2"
                   cols="6"
            >
                <div class="font-weight-bold text-nowrap mb-1">
                    PRODUCTO
                </div>
                <div class="text-black-50">
                    {{ product_classifications.name }}
                </div>
            </b-col>
            <b-col md="4"
                   class="mb-2"
                   cols="6"
                   v-if="product.state"
            >
                <div class="font-weight-bold text-nowrap mb-1">
                    ESTADO
                </div>
                <div class="text-black-50">
                    {{ product.state.lista }}
                </div>
            </b-col>
            <b-col md="4"
                   class="mb-2"
                   cols="6"
            >
                <div class="font-weight-bold text-nowrap mb-1">
                    EMPRESA
                </div>
                <div class="text-black-50">
                    {{ product.manufacturer.nombre }}
                </div>
            </b-col>
            <b-col md="4"
                   class="mb-2"
                   cols="6"
            >
                <div class="font-weight-bold text-nowrap mb-1">
                    FECHA DE CLASIFICACIÓN
                </div>
                <el-date-picker v-model="product.classification_date"
                                :clearable="false"
                                :editable="false"
                                size="mini"
                                value-format="yyyy-MM-dd"
                                format="yyyy-MM-dd"
                                @change="_updateProduct"
                                class="w-100"
                />
            </b-col>

            <b-col md="4"
                   class="mb-2"
                   cols="6"
            >
                <div class="font-weight-bold text-nowrap mb-1">

                    FECHA DEL DISEÑO DEL DOCUMENTO
                </div>
                <el-date-picker v-model="product.document_design_date"
                                :clearable="false"
                                :editable="false"
                                size="mini"
                                value-format="yyyy-MM-dd"
                                format="yyyy-MM-dd"
                                @change="_updateProduct"
                                class="w-100"
                />
            </b-col>

            <b-col md="4"
                   class="mb-2"
                   cols="6"
            >
                <div class="w-100">&nbsp;</div>
                <b-btn variant="info"
                       class="float-right mx-1 text-white"
                       size="sm"
                       @click="downloadClassification"
                >
                    <i class="fa fa-file-pdf-o"/>
                    Descargar
                </b-btn>
            </b-col>
        </b-row>

        <b-row class="my-3">
            <b-col cols="12"
                   class="text-justify"
            >
                La presente clasificación del producto
                <span class="font-weight-bold">{{ product_classifications.name }}</span>,
                fue realizada con base en las propiedades físico-químicas, la composición y demás documentos
                proporcionados por
                <span class="font-weight-bold">{{ product.manufacturer.nombre }}</span> a
                <span class="font-weight-bold">MEJORA Y SOLUCIONES SAS</span>, se realizó teniendo en cuenta los
                lineamientos del SISTEMA GLOBALMENTE ARMONIZADO DE CLASIFICACIÓN Y ETIQUETADO DE PRODUCTOS QUÍMICOS
                (SGA) Sexta edición revisada, 2015 y la legislación vigente (Decreto 1496 de 2018 y Resolución 0773 de
                2021), con el objetivo de determinar los peligros
                asociados, las clases de peligro correspondientes, las categorías de peligro,
                los pictogramas requeridos, las palabras de advertencia necesarias y cualquier otra información
                relevante para la correcta gestión del riesgo.
            </b-col>
        </b-row>


        <el-collapse>
            <el-collapse-item v-for="(danger, i) in product_classifications.grouped_classifications"
                              :key="i"
            >
                <template slot="title">
                    <b-row>
                        <b-col cols="12">
                            <h5 class="text-primary font-weight-bold mb-0">
                                {{ i + 1 }}. {{ danger.danger }}
                                <b-badge variant="secondary"
                                         class="ml-2"
                                >
                                    {{danger.classifications.length}}
                                </b-badge>
                            </h5>
                        </b-col>
                    </b-row>
                </template>

                <b-row>
                    <b-col cols="12">
                        <danger_card v-for="(classification, j) in danger.classifications"
                                     :classification="classification"
                                     :key="j"
                                     @saveClassification="saveClassification"
                        />
                    </b-col>
                </b-row>
            </el-collapse-item>
        </el-collapse>

        <b-row class="mt-3">
            <b-col class="text-justify">
                Es importante tener en cuenta estos peligros y las medidas de precaución correspondientes al manipular,
                almacenar y usar el producto <span class="font-weight-bold">{{ product_classifications.name }}</span>,
                con el fin de prevenir accidentes y proteger
                la salud y seguridad de las personas y el medio ambiente.
            </b-col>
        </b-row>

        <b-button
            v-if="showButton"
            variant="primary"
            class="scroll-to-top"
            @click="scrollToTop"
        >
            <i class="fa fa-angle-up"></i>
        </b-button>
    </div>
</template>

<script>

import {mapActions, mapState} from 'vuex';
import danger_card from './danger_card.vue';

export default {
    name: 'index',
    components: {
        danger_card
    },
    data() {
        return {
            showButton: false,
        };
    },
    async mounted() {
        const product_id = this.$route.params.product_id;
        const company_id = this.$route.params.company_id;

        await this.getProduct({product_id, company_id});
        await this.getProductClassifications({product_id, company_id});

        window.addEventListener("scroll", this.checkScroll);
    },
    computed: {
        ...mapState('calculator', [
            'product',
            'product_classifications'
        ])
    },
    methods: {
        ...mapActions('calculator', [
            'getProductClassifications',
            'getProduct',
            'downloadClassification',
            'updateProduct',
            'saveClassification'
        ]),
        checkScroll() {
            this.showButton = window.scrollY > 300;
        },
        scrollToTop() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        },
        async _updateProduct() {
            await this.updateProduct(false);
        }
    },
    beforeDestroy() {
        window.removeEventListener("scroll", this.checkScroll);
    },
};
</script>

<style>

.text-soluquim {
    color: #1a94c0;
}

.scroll-to-top {
    position: fixed;
    bottom: 20px;
    right: 20px;
    z-index: 9999;
    border-radius: 50%;
    width: 45px;
    height: 45px;
    padding: 0;
    font-size: 24px;
}
</style>
